import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnectionOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", { d: "M17 13C18.6569 13 20 11.6569 20 10C20 8.34315 18.6569 7 17 7C15.3431 7 14 8.34315 14 10C14 11.6569 15.3431 13 17 13ZM17 9C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11C16.4477 11 16 10.5523 16 10C16 9.44772 16.4477 9 17 9ZM9 3C11.2091 3 13 4.79086 13 7C13 7.88636 12.7117 8.70538 12.2238 9.36841L10.774 7.921L10.85 7.7613C10.9225 7.58531 10.9706 7.39669 10.9902 7.19967L11 7C11 5.89543 10.1046 5 9 5C8.66864 5 8.3561 5.08058 8.08091 5.22322L8.69595 5.844L6.62795 3.7789C7.22526 3.3383 7.94951 3.05987 8.73572 3.00859L9 3ZM6.31923 13.5431C7.60762 13.009 8.99214 12.8831 10.3048 13.1322L15.8807 18.7085C15.9607 19.1327 16.0009 19.5651 16 20C16 20.5523 15.5523 21 15 21C14.4477 21 14 20.5523 14 20C14 17.2386 11.7614 15 9 15C6.23858 15 4 17.2386 4 20C4 20.5523 3.55228 21 3 21C2.44772 21 2 20.5523 2 20C2.00382 17.173 3.70774 14.6258 6.31923 13.5431ZM17 14C19.7614 14 22 16.2386 22 19C22 19.1467 21.9684 19.286 21.9117 19.4115C21.8186 19.1085 21.6529 18.8245 21.4142 18.5858L16.832 14.0043L17 14Z" }), /* @__PURE__ */ _jsx("path", {
			d: "M4 4L20 20",
			stroke: "var(--main-color)",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export { SvgConnectionOff as ReactComponent };
